export type CsvCell = string | number | boolean | null | undefined;

export const downloadCSV = (
  title: string,
  header: readonly CsvCell[],
  rows: CsvCell[][],
): void => {
  const sanitize = (c: CsvCell) =>
    typeof c === "string" ? c.replaceAll(",", "").replace(/[\n\r]/g, "") : c;
  const rowsStrings = rows.map((r) => r.map(sanitize).join(","));
  const headerString = header.map(sanitize).join(",");
  openDownload(generateCSVDataURIWithHeader(headerString, rowsStrings), title);
};

export const generateCSVDataURIWithHeader = (
  header: string,
  rows: string[],
): string => {
  const csv = rows.reduce((csv, row) => `${csv}\n${row}`, header);
  return generateCSVDataURI(csv);
};

export const generateCSVDataURI = (data: string): string => {
  return `data:text/csv;charset=utf-8,${encodeURIComponent(data)}`;
};

export function openDownload(data: string, title: string): void {
  const link = document.createElement("a");
  link.setAttribute("href", data);
  link.setAttribute("download", title);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}

/**
 * Downloads a file from a URL by fetching it as a blob first.
 * This ensures the file is saved to disk rather than opened in the browser,
 * which is necessary for cross-origin URLs where the `download` attribute
 * on anchor tags is ignored.
 */
export async function downloadFileAsBlob(
  url: string,
  filename: string,
): Promise<void> {
  const response = await fetch(url);
  const blob = await response.blob();
  const blobUrl = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = blobUrl;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(blobUrl);
}

export function sanitizeCsvHeader(inputString: string): string {
  return inputString.replace(/[^a-zA-Z0-9\s]/g, "");
}
